import React from "react"

export default function CloseRed() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <circle cx="12.6475" cy="12.4756" r="12" fill="#FF3B30" />
      <g clipPath="url(#clip0_1_4)">
        <path d="M14.8977 12.4762L18.0249 9.349C18.4087 8.96525 18.4087 8.34306 18.0249 7.959L17.3299 7.264C16.9462 6.88025 16.324 6.88025 15.9399 7.264L12.8127 10.3912L9.68554 7.264C9.30179 6.88025 8.6796 6.88025 8.29554 7.264L7.60054 7.959C7.21679 8.34275 7.21679 8.96494 7.60054 9.349L10.7277 12.4762L7.60054 15.6034C7.21679 15.9871 7.21679 16.6093 7.60054 16.9934L8.29554 17.6884C8.67929 18.0721 9.30179 18.0721 9.68554 17.6884L12.8127 14.5612L15.9399 17.6884C16.3237 18.0721 16.9462 18.0721 17.3299 17.6884L18.0249 16.9934C18.4087 16.6096 18.4087 15.9874 18.0249 15.6034L14.8977 12.4762Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_1_4">
          <rect width="11" height="16" fill="white" transform="translate(7.31273 4.47619)" />
        </clipPath>
      </defs>
    </svg>
  )
}
